export default [
    {
        "name": "Bleeding Edge",
        "thumbnail": "bleeding-edge-thumbnail.jpg",
        "company": "Ninja Theory",
        "tags": "CMS Website, Forum",
        "primaryColour": "#2c3e58",
        "link": "https://www.bleedingedge.com",
        "shortlink": "bleedingedge.com",
        "coming_soon": false,
        "developed_by": "Developed at Staak",
        "images": [
            {
                "image": "bleeding-edge-media.jpg",
                "alt": "Image showing the media section of bleedingedge.com",
                "caption": "The media section of the website is split into different categories, all managed using WordPress Custom Post Types.",
            },
            {
                "image": "bleeding-edge-forum.jpg",
                "alt": "Image showing the home screen of the Bleeding Edge forum",
                "caption": "The forum's homepage was heavily customised featuring bespoke tabbed content, search, sort and filter functionality.",
            }
        ],
        "intro": [
            "Ninja Theory are an Xbox Game Studios developer with an impressive catalogue of games.",
        ],
        "description": [
            "Bleeding Edge is “a fast and frenetic 4v4 team brawler where every fighter comes mechanically enhanced for mayhem!” The game was to be released March 2020 and needed an online presence which would be unveiled at E3 2019.",
            "Like its characters the Bleeding Edge site had to evolve and adapt throughout its life. On launch for E3 2019, the website provided users a way to seamlessly login via their Xbox Live account and check their eligibility for the ‘technical alpha’ phase which was presented in the form of a bespoke survey. The survey integrated with a bespoke API to store in a database, content of which was then imported into Power Bi where boards were made to filter and extract eligible users.",
            "User accounts worked across the website and forum to enable a seamless browsing experience. Users approved for the technical alpha were granted exclusive access to the forum’s alpha section, which remained restricted to all other visitors.",
            "Content managed via headless WordPress allowed the flexibility to build a bespoke frontend using an SPA framework.",
            "A redis cache stored content until updates needed to be made, which made site speed lightning fast. WordPress’ API connects seamlessly to bespoke API’s which updated the caching system accordingly.",
            "Internationalisation was a big consideration throughout development, with content needing to be translated into 19 languages. String translation was integrated into the frontend of the website and a multilingual plugin for the CMS. A language picker on the website switched the website locales and served users the content in their desired language.",
            "Website load and stress testing played a big part in the development of the project. With such a big launch platform and a lot of users predicted to visit the website, it had to hold up under massive traffic loads. Configuring Azure’s server infrastructure and utilising website monitoring, coupled with an optimised and robust website build enabled a successful launch and continues throughout the website’s evolution.",
        ],
        "tech": "Vue.js, WordPress, NodeBB, Node.js, Express, Passport.js, Microsoft login auth, Power Bi, Redis, Azure, Localisation",
    },
    {
        "name": "HMS Belfast 80th Celebration",
        "thumbnail": "hms-belfast-website-thumbnail.jpg",
        "company": "Imperial War Museum",
        "tags": "Website",
        "primaryColour": "#F77C62",
        "link": "https://www.iwm.org.uk/history/hmsb80/",
        "shortlink": "iwm.org.uk/history/hmsb80",
        "coming_soon": false,
        "developed_by": "Developed at Staak",
        "images": [
            {
                "image": "final-years.jpg",
                "alt": "Image showing one of the HMS Belfast events seen from the timeline",
                "caption": "The main landing page of the HMS Belfast website showed the main events in the Belfast's history, in the form of a carousel. Background video, audio and carousel animations set the atmosphere and encouraged user's to click through to learn more.",
            },
        ],
        "intro": [
            "The Imperial War Museum is a British national museum organisation, with five locations in England which document the conflicts that have shaped the world.",
        ],
        "description": [
            "Staak were approached to develop an interactive website to complement and accompany the HMS Belfast 80th anniversary celebrations.",
            "The website was built to consider a wide range of users, from school children to families and military enthusiasts through to those who remember The Belfast as a serving military vessel.",
            "The website is built around a central ‘timeline’ which branches off to specific events the Belfast was involved in.",
            "Bringing to life the wartime contributions of The Belfast whilst contextualising these stories  against the wider backdrop of WW2 was a challenge. We employed a number of techniques across the site including a bespoke audio soundtrack, embedded video backgrounds and archive cinematography to create an emotive and immersive experience.",
            "To add a further level of gravitas, we leveraged exclusive footage from the servicemen and women telling their stories and sharing their memories and integrated these throughout the site.",
            "Each timeline milestone was developed using modular components to quickly and easily make page templates for each of the Belfast’s stories.",
            "The timeline display uses a carousel with custom CSS animations to set the tone for the overall story of The Belfast and engage users to click through and learn more about its past.",
        ],
        "tech": "Vue.js, Web Audio & Video, GSAP",
    },
    {
        "name": "D-Day 75th Anniversary",
        "thumbnail": "d-day-75-thumbnail.jpg",
        "company": "Imperial War Museum",
        "tags": "Website",
        "primaryColour": "#8E95A4",
        "link": "https://www.iwm.org.uk/history/dday/",
        "shortlink": "iwm.org.uk/history/dday",
        "coming_soon": false,
        "developed_by": "Developed at Staak",
        "images": [
            {
                "image": "dday-popups.jpg",
                "alt": "Example of popups available on all images which provide more detail",
                "caption": "Some elements on the website show a red plus icon which users can click to read more about specific items shown in an image.",
            },
            {
                "image": "dday-horizontal-scroll.jpg",
                "alt": "Image showing a break between vertical and horizontal content",
                "caption": "The events of D-Day were separated into sections and split up on the website using vertical and horizontal scrolling.",
            },
        ],
        "intro": [
            "The Imperial War Museum is a British national museum organisation, with five locations in England which document the conflicts that have shaped the world.",
        ],
        "description": [
            "Off the back of the success of the HMS Belfast 80th anniversary website, Staak were again invited to collaborate with The IWM to develop an interactive website to commemorate the 75th anniversary of the D-Day landings and provide a unique framework to tell the stories of those involved.",
            "We opted to split the enormous catalogue of visual and written content of the D-Day landings into what became the 3 main ‘timelines’ of the website: Land, Sea & Air. To differentiate between the timelines, we created a mechanic whereby the scroll direction of content morphed when a new timeline was in view.",
            "A helpful side menu was integrated so users could click and navigate to a specific piece of content should they be a returning visitor or knew which section they wished to explore.",
            "We also crafted ‘factoids’ - prompts which labelled images. When these were clicked, they gave the user further information on that topic or showcased a particularly interesting story in more detail.",
            "The website navigation was laid out in the same way as the content scroll, so users could get a sense of the nested timeline of events and the wider narrative of the conflict.",
        ],
        "tech": "Vue.js, ScrollMagic, GSAP",
    },
    {
        "name": "The Rugby Company",
        "thumbnail": "the-rugby-company-thumbnail.jpg",
        "company": "The Rugby Company",
        "tags": "eCommerce Website",
        "primaryColour": "#e4a517",
        "link": "https://www.therugbycompany.co.uk/",
        "shortlink": "therugbycompany.co.uk",
        "coming_soon": false,
        "developed_by": "Developed at Staak",
        "images": [
            {
                "image": "the-rugby-company-category.jpg",
                "alt": "Image of the store category page",
                "caption": "The category page of the store showcases the stunning products.",
            },
            {
                "image": "the-rugby-company-product.jpg",
                "alt": "Image showing the website product page",
                "caption": "The product page features details close-up photography of the products. Information relating to the legendary player the jersey was produced is also prominent on the page.",
            },
        ],
        "intro": [
            "The Rugby Company are a British fashion company who study vintage rugby jerseys and craft them into garments to grace a modern gent’s wardrobe.",
        ],
        "description": [
            "A bespoke website was developed using WooCommerce and hosted on WP Engine.",
            "The website was developed to be performant, optimised and SEO friendly. The Rugby Company web build concentrated on a high-end visual showcase combined with a slick user experience which saw conversions grow rapidly in a short space of time.",
            "A bespoke, yet user-friendly checkout process was developed to enhance the experience and capitalise on converting web traffic to retail orders.",
            "Contemporary sales channels were considered from the outset by syncing products to a standalone WooCommerce store and Facebook marketplace, promoting products across all key platforms.",
            "Newsletter signups were integrated with the Mailchimp API, to enhance email marketing strategies and eventually allow for a simplified handover to the business owners.",
            "We continued to study site usage post-build, monitoring user sessions with HotJar and Google Analytics. This showed key insights into how users were interacting with the website and where optimisations and updates could be made as and when required.",
        ],
        "tech": "WordPress, WooCommerce, Mailchimp, HotJar, WP Engine, Google Analytics, Facebook Marketplace",
    },
    {
        "name": "HMS Belfast Exhibition Installation",
        "thumbnail": "hms-belfast-installation-thumbnail.jpg",
        "company": "Imperial War Museum",
        "tags": "Exhibition Installation",
        "primaryColour": "#404256",
        "link": "https://www.iwm.org.uk/events/hms-belfast/serving-the-seas",
        "shortlink": "Example photography seen on board",
        "coming_soon": false,
        "developed_by": "Developed at Staak",
        "images": [],
        "intro": [
            "The Imperial War Museum is a British national museum organisation, with five locations in England which document the conflicts that have shaped the world.",
        ],
        "description": [
            "The Imperial War Museum were thrilled with the digital offering for The Belfast’s 80th anniversary celebrations. So much so that they asked us to collaborate on physical installations within the ship itself. The museum decided to dedicate a room within The Belfast to showcase the experience on touch-screen devices, presenting a great opportunity to further the stories surfaced within the celebrations to a wider audience.",
            "The website was adapted to run in a full-screen Google Chrome browser and without mouse and keyboard to be a ‘touch’ only experience.",
            "Optimisation of the experience was necessary to ensure that it could be used throughout the entirety of a ‘working day’ without faulting with a high volume of visitors and considering the technical fluency of visitors. Further stress and load testing identified improvements which were necessary for the interactive experience to run as smoothly as possible and be able to stand up against extreme usage.",
            "Additional features were added to enable the experience to ‘reset’ itself after a period of inactivity and to show relevant messaging to entice passers-by to use the installation.",
        ],
        "tech": "Vue.js, Audio & Video",
    },
    {
        "name": "Exhibit Virtual",
        "thumbnail": "exhibit-virtual-thumbnail.jpg",
        "company": "Exhibit Interactive",
        "tags": "CMS Website",
        "primaryColour": "#0d7fd8",
        "link": "https://exhibitvirtual.online/",
        "shortlink": "exhibitvirtual.online",
        "coming_soon": true,
        "developed_by": "",
        "images": [
            {
                "image": "exhibit-virtual-launch.jpg",
                "alt": "Image showing how to enter the virtual exhibition",
                "caption": "Before visiting a virtual exhibition, users can read more about the event. Some events require registration before being able to visit the exhibition. Exhibitions launch in a fullscreen window to show it off in all it's glory.",
            },
        ],
        "intro": [
            "",
        ],
        "description": [
            "",
        ],
        "tech": "WordPress, Elementor, Pano2VR",
    },
    {
        "name": "Toujours Jaune",
        "thumbnail": "toujours-jaune-thumbnail.jpg",
        "company": "Staak",
        "tags": "Website, WebGL",
        "primaryColour": "#F19D2C",
        "link": "http://www.toujoursjaune.com/",
        "shortlink": "toujoursjaune.com",
        "coming_soon": false,
        "developed_by": "Developed at Staak",
        "images": [
            {
                "image": "toujours-jaune-tshirt.jpg",
                "alt": "Yellow jersey before user interaction",
                "caption": "The coveted yelow jersey is the trigger to play the game. After a period of inactivity the jersey ;bounces' to draw attention until ultimately clicked on.",
            },
            {
                "image": "toujours-jaune-tshirt-particles.jpg",
                "alt": "On mouse hover, the yellow jersey begins to separate into particles",
                "caption": "On mouse hover the yellow jersey begins to separate into particles. The explosion into particles doesn't fully animate until after a user click.",
            },
            {
                "image": "toujours-jaune-winner.jpg",
                "alt": "The jersey transforms into the face of a winning rider, with stats from the victory",
                "caption": "The exploded particles of the yellow jersey transform magically into an illustrated version of a past Tour winner. Stats from the winning year and a short bio of the winner animate into position.",
            },
            {
                "image": "toujours-jaune-doper.jpg",
                "alt": "Winners who later tested positive for illegal substances cause game over",
                "caption": "The disgraced winners of the Tour cause a 'game-over' state, ending your run of Tourjours Jaune.",
            },
        ],
        "intro": [
            "An experience developed internally at Staak to flex creative and technical muscles and continue to broaden our collective knowledge.",
        ],
        "description": [
            "With the majority of the studio having an interest in cycling it seemed fitting to conjure up a project revolving around the iconic theme of The Tour de France.",
            "Our idea was to create an interactive experience in which cycling fans could learn about the rich history of the event in a unique and entertaining framework. Some of the past winners have since been disgraced for drug use and we designed this to be part of the game mechanic!",
            "Exploring WebGL (specifically three.js) and user interaction became the focus point of the project. Concepts were discussed and an idea came to fruition - morphing the famous yellow jersey of the Tour into one of the past winners combined with a ‘stick or twist’ game format.",
            "Models which were exported from various modelling applications (Blender, C4D) which shaped the workflow from design to development.",
            "Animations and audio were combined to bring the showcase to life and make a rounded ‘game’ experience...",
            "The transformation of the yellow jersey into that of past winners was done by animating vertex positions from our 3D models resulting in a series of beautiful low-poly portraits. Easing and other animation effects combined to create a dynamic, fluid visual result.",
            "Simulating lighting and shadows was achieved using various optimised techniques. For example, matcaps can simulate lighting to create beautiful visuals without impacting performance. Users can play on both desktop and mobile devices, allowing a broad range of interaction and ‘shareability’.",
            "When a user posts their score to social media, a bespoke share asset is dynamically generated based on user score and a random rider image. This was possible with a bespoke API and utilising the features of Puppeteer.",
            "WebGL and UI elements combine to create a stunning visual piece to celebrate (and disgrace) winners of the Tour de France. ",
            "Vive le tour!",
        ],
        "tech": "Vue.js, Node.js, Express, WebGL / three.js, GSAP, Puppeteer",
    },
    {
        "name": "Zodiac Hustle",
        "thumbnail": "zodiac-hustle-thumbnail.jpg",
        "company": "Staak",
        "tags": "Website, WebGL",
        "primaryColour": "#eb1409",
        "link": "https://www.zodiac-hustle.com/",
        "shortlink": "zodiac-hustle.com",
        "coming_soon": false,
        "developed_by": "Developed at Staak",
        "images": [
            {
                "image": "zodiac-hustle-start.jpg",
                "alt": "Screen before entering the game",
                "caption": "The start screen displays simple UI which mysteriously fades to show the game once a user clicks the start button.",
            },
            {
                "image": "zodiac-hustle-congratulations.jpg",
                "alt": "A congratualtion popup shows when you correctly guess the rat position",
                "caption": "After a sequence of cup movements and smooth camera motion, the user is prompted to choose which cup they think the golden rat is hiding. As the levels progress, the difficulty and spped of cup movement increases.",
            },
        ],
        "intro": [
            "An experience developed internally at Staak to flex creative and technical muscles and continue to grow and broaden knowledge.",
        ],
        "description": [
            "Zodiac Hustle started life as a in-house sandbox project to sharpen our skills in areas our clients were looking to explore.",
            "Zodiac Hustle was created to celebrate the Chinese New Year 2020, the year of the rat.",
            "The game is based on the classic gambling ‘cup game’ where a player tries to guess under which cup a specific object lies. A model of a golden rat was used in this case, which hides under a stylised cup.",
            "Each level starts with smooth camera motion for the user to try and track the rat. The cup locations and movement is simulated per level so no two games are the same. Calculations are made to ensure the cups never collide or move into positions which wouldn’t be possible in reality.",
            "The intro and outro screens which ‘bookended’ gameplay used a masking technique and render targets to be able to transition between the gameplay states and added a level of cinematic polish. Users progress through levels of increasing difficulty to see how long they can identify the location of the golden rat. At the point the user fails to find the target, the game transitions back to a ‘game over’ state where they can share their achievement through social media.",
            "Performance and mobile compatibility enhance the gameplay, allowing a smooth experience on both desktop and mobile.",
        ],
        "tech": "Vue.js, Node.js, Express, WebGL / three.js, GSAP",
    },
    {
        "name": "Winter Tidings",
        "thumbnail": "winter-tidings-thumbnail.jpg",
        "company": "Staak",
        "tags": "Website, WebGL",
        "primaryColour": "#54418a",
        "link": "http://www.wintertidings.com/",
        "shortlink": "wintertidings.com",
        "coming_soon": false,
        "developed_by": "Developed at Staak",
        "images": [],
        "intro": [
            "An experience developed internally at Staak to flex creative and technical muscles and continue to grow and broaden knowledge.",
        ],
        "description": [
            "Winter Tidings was our Christmas gift to the world. Some studios do Christmas cards, we made an emotive message sending service gift-wrapped with storytelling, modelling and some pretty sweet code.",
            "Winter Tidings was an introductory into the world of WebGL. A project released around Christmas time, it is a way to share messages with friends and family.",
            "Developed in WebGL, Winter Tidings combines an illustrative-style intro through to an immersive, stunning 3D environment for the main experience.",
            "The core of Winter Tidings is to send a message to a loved one at Christmas. The message was ‘attached to a snowflake’ — and as in nature, no two were the same. Each was a bespoke digital rendering to the user.",
            "After users had written their message it was rendered in the 3D world. A prompt would guide our visitors into gesturing with their device, triggering the snowflake to shatter into pieces. The shattered pieces would reform when received by the recipient.",
        ],
        "tech": "Vue.js, Node.js, Express, WebGL / three.js, GSAP",
    },
    {
        "name": "Battle Crackers",
        "thumbnail": "battle-crackers-thumbnail.jpg",
        "company": "Staak",
        "tags": "Website, WebGL",
        "primaryColour": "#00c0e0",
        "link": "http://www.battlecrackers.com/",
        "shortlink": "battlecrackers.com",
        "coming_soon": true,
        "developed_by": "Developed at Staak",
        "images": [
            {
                "image": "battle-crackers-play.jpg",
                "alt": "Screen showing that name must be entered before playing",
                "caption": "Before playing a user can enter their battle name before taking on an opponent.",
            },
            {
                "image": "battle-crackers-find-opposition.jpg",
                "alt": "Image shows the game trying to match with an opposition",
                "caption": "Users are paired with other players waiting in game lobbies. When matched, both players are shown a syncronised animation to kick-off the game.",
            },
            {
                "image": "battle-crackers-win.jpg",
                "alt": "Confetti and sound effects play when winning the game",
                "caption": "Audio, animations and confetti signal you're the winner and are presented a classic cracker joke along with a digital prize.",
            },
        ],
        "intro": [
            "",
        ],
        "description": [
            "",
        ],
        "tech": "Vue.js, Node.js, Express, WebGL / three.js, Cannon.js, Socket.io, GSAP",
    },
    {
        "name": "Trunk Dunk",
        "thumbnail": "trunk-dunk-thumbnail.jpg",
        "company": "Staak",
        "tags": "Website, WebGL, AR",
        "primaryColour": "#0693CE",
        "link": "http://www.trunkdunk.com/",
        "shortlink": "trunkdunk.com",
        "coming_soon": true,
        "developed_by": "Developed at Staak",
        "images": [
            {
                "image": "trunk-dunk-intro.jpg",
                "alt": "An animated elephant blowing bubbles",
                "caption": "Custom animations run on each of the section as the user scroll down the website.",
            },
            {
                "image": "trunk-dunk-ingredients.jpg",
                "alt": "Showing the ingrdients used to make the beer",
                "caption": "Sequential animations reveal information about the beer making process."
            },
            {
                "image": "trunk-dunk-outcome.jpg",
                "alt": "Image showing illustrated elephant trunk drinking from beer glass",
                "caption": "Illustrations & animations give life and character to the product.",
            },
        ],
        "intro": [
            "",
        ],
        "description": [
            "",
        ],
        "tech": "Vue.js, SCSS, Node.js, Express, Puppeteer, WebGL / three.js, three.ar.js",
    },
    {
        "name": "TwoCan",
        "thumbnail": "twocan-thumbnail.jpg",
        "company": "Staak",
        "tags": "Website, App",
        "primaryColour": "#30347b",
        "link": "https://www.twocan.app/",
        "shortlink": "twocan.app",
        "coming_soon": true,
        "developed_by": "Developed at Staak",
        "images": [
            {
                "image": "twocan-intro-screens.png",
                "alt": "Image showing TwoCann on a mobile phone screen",
                "caption": "TwoCan, the app for making lists with friends.",
            },
            {
                "image": "twocan-list-screens.png",
                "alt": "Image showing list items checked off and sharing feature",
                "caption": "With it's intuitive UI, it's really easy to make lists and share with friends.",
            },
        ],
        "intro": [
            "",
        ],
        "description": [
            "",
        ],
        "tech": "Vue.js, React Native, Expo, Firebase",
    }
];
